import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import DisplayImage from "../DisplayImage";
import { MdDelete } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from "react-toastify";
import "../../css/Admin-Awards/AdminEditAwards.css";
import Spinner from "../Spinner";

const AdminEditAwards = ({ onClose, productData, fetchData, projectKey }) => {
  const [uploadAwardLogo, setUploadAwardLogo] = useState(0);
  const [uploadAwardCertificates, setUploadAwardCertificates] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    ...productData,
    awardName: productData?.awardName,
    awardInstitute: productData?.awardInstitute,
    awardPosition: productData?.awardPosition,
    awardYear: productData?.awardYear,
    awardOrder:productData?.awardOrder,
    awardLogo: productData?.awardLogo || [],
    awardCertificates: productData?.awardCertificates || [],
  });

  const [fullScreenImage, setFullScreenImage] = useState("");
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };

  async function handleUploadLogo(e) {
    setLoading(true);
    const image = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.awardName}-${image.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Handle state changes such as progress, pause, and resume
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          setUploadAwardLogo(progress);
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          reject(error);
          setLoading(false);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              awardLogo: [...prev.awardLogo, downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  async function handleUploadCertificates(e) {
    setLoading(true);
    const video = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.awardName}-${video.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, video);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Image Upload is " + progress + "% done");
          setUploadAwardCertificates(progress);
        },
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              awardCertificates: [
                ...(prev.awardCertificates || []),
                downloadURL,
              ],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  const handleDeleteLogo = (index) => {
    //console.log("clicl");
    const newLogos = [...data.awardLogo];
    newLogos.splice(index, 1);
    setData((pre) => {
      return {
        ...pre,
        awardLogo: [...newLogos],
      };
    });
  };

  const handleDeleteCertificates = (index) => {
    const newCertificates = [...data.awardCertificates];
    newCertificates.splice(index, 1);
    setData((pre) => ({
      ...pre,
      awardCertificates: newCertificates,
    }));
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    //console.log(projectKey);
    const docRef = doc(db, "awards", projectKey);
    await updateDoc(docRef, data);
    setLoading(false);
    toast.success("Award Updated");
    fetchData();
    onClose();
  };
  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="overlay">
      <div className="edit-product-modal">
        <div className="modal-header">
          <h2 className="title">Edit Award</h2>
          <div className="close-icon" onClick={onClose}>
            <CgClose />
          </div>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <label htmlFor="awardName">Award Name :</label>
          <input
            type="text"
            id="awardName"
            placeholder="Enter Award name"
            value={data.awardName}
            name="awardName"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="awardInstitute">Institute Name :</label>
          <input
            type="text"
            id="awardInstitute"
            placeholder="Enter Institute Name"
            value={data.awardInstitute}
            name="awardInstitute"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="awardPosition">Position :</label>
          <input
            type="text"
            id="awardPosition"
            placeholder="Enter your Position"
            value={data.awardPosition}
            name="awardPosition"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="awardYear">Year :</label>
          <input
            type="text"
            className="input"
            placeholder="Enter the Year"
            value={data.awardYear}
            name="awardYear"
            onChange={handleOnChange}
          />
          <label htmlFor="awardOrder">Order :</label>
          <input
            type="number"
            id="awardOrder"
            placeholder="Enter the Order"
            value={data.awardOrder}
            name="awardOrder"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="awardLogo" className="label">
          Award Logo :
          </label>
          <label htmlFor="awardLogo">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Award Logo</p>
                <input
                  type="file"
                  id="awardLogo"
                  className="hidden"
                  onChange={handleUploadLogo}
                />
              </div>
            </div>
          </label>
          {uploadAwardLogo > 0 && uploadAwardLogo < 100 && (
            <label
              style={{ color: "blue", textAlign: "center" }}
            >{`Upload is ${uploadAwardLogo}% done`}</label>
          )}

          <div>
            {data.awardLogo.length > 0 ? (
              <div className="image-preview">
                {data.awardLogo.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteLogo(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Award Logo</p>
            )}
          </div>

          <label htmlFor="awardCertificates" className="label">
            Certificates:
          </label>
          <label htmlFor="awardCertificates">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Certificates</p>
                <input
                  type="file"
                  id="awardCertificates"
                  className="hidden"
                  onChange={handleUploadCertificates}
                />
              </div>
            </div>
          </label>
          {uploadAwardCertificates > 0 &&
            uploadAwardCertificates < 100 && (
              <label
                style={{ color: "blue", textAlign: "center" }}
              >{`Upload is ${uploadAwardCertificates}% done`}</label>
            )}

          <div>
            {data.awardCertificates.length > 0 ? (
              <div className="image-preview">
                {data.awardCertificates.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteCertificates(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">
                *Please Upload Award Certificates
              </p>
            )}
          </div>
          <button className="submit-button">Update Award</button>
        </form>
      </div>
      {openFullScreenImage && (
        <DisplayImage
          onClose={() => setOpenFullScreenImage(false)}
          imageUrl={fullScreenImage}
        />
      )}
    </div>
  );
};

export default AdminEditAwards;
